import * as form from '../form';

export const foreignContacts = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Name: form.name(xitem.Name),
        NameNotApplicable: form.notapplicable(xitem.NameNotApplicable),
        NameExplanation: form.textarea(xitem.NameExplanation),
        FirstContact: form.datecontrol(xitem.FirstContact),
        LastContact: form.datecontrol(xitem.LastContact),
        Methods: form.checkboxgroup(xitem.Methods),
        MethodsExplanation: form.textarea(xitem.MethodsExplanation),
        Frequency: form.radio(xitem.Frequency),
        FrequencyExplanation: form.textarea(xitem.FrequencyExplanation),
        Relationship: form.checkboxgroup(xitem.Relationship),
        RelationshipExplanation: form.textarea(xitem.RelationshipExplanation),
        Aliases: form.collection(
          ((xitem.Aliases || {}).items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                Has: form.branch(yitem.Has),
                Alias: form.name(yitem.Alias),
                AliasDescription: form.radio(yitem.AliasDescription), // PVQ Only
                AliasDescriptionOtherExplanation: form.textarea(yitem.AliasDescriptionOtherExplanation), // PVQ Only
              },
            };
          })
        ),
        Citizenship: form.country(xitem.Citizenship),
        Birthdate: form.datecontrol(xitem.Birthdate),
        BirthdateNotApplicable: form.notapplicable(xitem.BirthdateNotApplicable),
        Birthplace: form.location(xitem.Birthplace),
        BirthplaceNotApplicable: form.notapplicable(xitem.BirthplaceNotApplicable),
        BirthplaceExplanation: form.textarea(xitem.BirthplaceExplanation),
        Address: form.location(xitem.Address),
        AlternateAddress: form.physicaladdress(xitem.AlternateAddress),
        AddressNotApplicable: form.notapplicable(xitem.AddressNotApplicable),
        InUsaNotApplicable: form.notapplicable(xitem.InUsaNotApplicable),
        Employer: form.text(xitem.Employer),
        EmployerNotApplicable: form.notapplicable(xitem.EmployerNotApplicable),
        EmployerAddress: form.location(xitem.EmployerAddress),
        EmployerAddressNotApplicable: form.notapplicable(xitem.EmployerAddressNotApplicable),
        HasAffiliations: form.branch(xitem.HasAffiliations),
        Affiliations: form.textarea(xitem.Affiliations),
        HowCitizenshipAcquired: form.text(xitem.HowCitizenshipAcquired), // PVQ Only
        HowCitizenshipAcquiredNotApplicable: form.notapplicable(xitem.HowCitizenshipAcquiredNotApplicable), // PVQ Only
        RelationshipPvq: form.radio(xitem.RelationshipPvq), // PVQ Only
        Email: form.email(xitem.Email), // PVQ Only
        EmailNotApplicable: form.notapplicable(xitem.EmailNotApplicable), // PVQ Only
        Telephone: form.telephone(xitem.Telephone), // PVQ Only
        Occupation: form.text(xitem.Occupation), // PVQ Only
        OccupationNotApplicable: form.notapplicable(xitem.OccupationNotApplicable), // PVQ Only
        ForeignDisciplines: form.checkboxgroup(xitem.ForeignDisciplines), // PVQ Only
        ForeignDisciplinesOtherExplanation: form.textarea(xitem.ForeignDisciplinesOtherExplanation), // PVQ Only
        ForeignDisciplinesNotApplicable: form.notapplicable(xitem.ForeignDisciplinesNotApplicable), // PVQ Only
        ForeignAssociationDescription: form.textarea(xitem.ForeignAssociationDescription), // PVQ Only
        ForeignAssociationDescriptionNotApplicable: form.notapplicable(xitem.ForeignAssociationDescriptionNotApplicable), // PVQ Only
        HasObligations: form.branch(xitem.HasObligations), // PVQ Only
        Obligations: form.textarea(xitem.Obligations), // PVQ Only
        NeverWorked: form.checkbox(xitem.NeverWorked), // PVQ Only
      },
    };
  });
  // PVQ Only
  const spouseForeignContactItems = ((data.SpouseForeignContactsList || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        ListedPreviously: form.branch(xitem.ListedPreviously),
        Name: form.name(xitem.Name),
        LastContact: form.datecontrol(xitem.LastContact),
        Frequency: form.radio(xitem.Frequency),
        FrequencyExplanation: form.textarea(xitem.FrequencyExplanation),
        SpouseRelationship: form.radio(xitem.SpouseRelationship),
        SpouseRelationshipExplanation: form.textarea(xitem.SpouseRelationshipExplanation),
        Relationship: form.radio(xitem.Relationship),
        RelationshipExplanation: form.textarea(xitem.RelationshipExplanation),
        Aliases: form.collection(
          ((xitem.Aliases || {}).items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                Has: form.branch(yitem.Has),
                Alias: form.name(yitem.Alias),
                AliasDescription: form.radio(yitem.AliasDescription),
                AliasDescriptionOtherExplanation: form.textarea(yitem.AliasDescriptionOtherExplanation),
              },
            };
          })
        ),
        Citizenship: form.country(xitem.Citizenship),
        CitizenshipNotApplicable: form.notapplicable(xitem.CitizenshipNotApplicable),
        Birthdate: form.datecontrol(xitem.Birthdate),
        BirthdateNotApplicable: form.notapplicable(xitem.BirthdateNotApplicable),
        Birthplace: form.location(xitem.Birthplace),
        BirthplaceNotApplicable: form.notapplicable(xitem.BirthplaceNotApplicable),
        Address: form.location(xitem.Address),
        AddressNotApplicable: form.notapplicable(xitem.AddressNotApplicable),
        InUsaNotApplicable: form.notapplicable(xitem.InUsaNotApplicable),
        ForeignDisciplines: form.checkboxgroup(xitem.ForeignDisciplines),
        ForeignDisciplinesOtherExplanation: form.textarea(xitem.ForeignDisciplinesOtherExplanation),
        ForeignDisciplinesNotApplicable: form.notapplicable(xitem.ForeignDisciplinesNotApplicable),
        ForeignAssociationDescription: form.textarea(xitem.ForeignAssociationDescription),
        ForeignAssociationDescriptionNotApplicable: form.notapplicable(xitem.ForeignAssociationDescriptionNotApplicable),
        Obligations: form.textarea(xitem.Obligations),
      },
    };
  });
  return {
    HasForeignContacts: form.branch(data.HasForeignContacts),
    List: form.collection(items, (data.List || {}).branch),
    HasSpouseForeignContacts: form.branch(data.HasSpouseForeignContacts),
    SpouseForeignContactsList: form.collection(spouseForeignContactItems, (data.SpouseForeignContactsList || {}).branch),
  };
};
